<template>
  <v-dialog v-model="scheduleDetailsModal" scrollable persistent full-width max-width='933'>
    <v-card class="pl-5 pr-5 no-details">
        <v-card-title class="pa-0 pt-4 pb-3">
          <v-flex>
            <span class="mt-2 mb-2 headline" v-if="schedule.id === ''">Novo Agendamento</span>
            <span class="mt-2 mb-2 headline" v-else>Agendamento: {{ schedule.controlNumber }}</span>
          </v-flex>
          <v-spacer></v-spacer>
          <v-flex class="text-xs-right">
            <v-btn class="ma-0" icon @click.native="onCloseModal">
              <v-icon>close</v-icon>
            </v-btn>
          </v-flex>
          <v-flex xs12 class="mt-2">
            <hr>
          </v-flex>
        </v-card-title>
        <v-slide-x-transition mode="out-in" v-if="selectedScheduleHasItens">
          <div>
            <select-item/>
            <v-flex class="text-xs-right pt-2" >
              <v-btn color="green" style="color: #fff;" left :disabled="hasCategorySelectedAndSelectedItens" @click.prevent="finishedSelectedItem">próximo</v-btn>
            </v-flex>
          </div>
        </v-slide-x-transition>
        <v-slide-x-transition mode="out-in" v-else-if="schedule.id === ''">
          <search-condominium/>
        </v-slide-x-transition>
        <v-slide-x-transition mode="out-in" v-else>
          <schedule-details/>
        </v-slide-x-transition>
        <v-progress-linear class="loading-modal-scheule" v-if="loadingScheduleActions || alteredScheduleSaving" color="error" height="2" v-bind:indeterminate="true"></v-progress-linear>        
    </v-card>
  </v-dialog>
</template>

<script>
import selectItem from './selectItem'
import searchCondominium from './SearchCondominium'
import scheduleDetails from './ScheduleDetails'

export default {
  name: 'schedule-modal',
  components: {
    'select-item': selectItem,
    'search-condominium': searchCondominium,
    'schedule-details': scheduleDetails
  },
  data () {
    return {
      loadingNew: false,
      menu: false,
      printIt: false,
      step: 0
    }
  },
  methods: {
    next () {
      this.step = this.step + 1
    },
    hideTip () {
      this.showTip = false
    },
    finishedSelectedItem () {
      this.$store.commit('selectScheduleItens', this.$store.getters.selectedItens)
      this.$store.commit('resetItemForScheduled')
    },
    onCloseModal () {
      this.scheduleDetailsModal = false
    }
  },
  computed: {
    loadingScheduleActions () {
      return this.$store.getters.loadingScheduleActions
    },
    schedule () {
      return this.$store.getters.selectedSchedule
    },
    scheduleDetailsModal: {
      get () {
        return this.$store.getters.scheduleDetailsModal
      },
      set () {
        this.$store.commit('toggleScheduleDetailsModal', false)
      }
    },
    hasSelection () {
      return this.$store.getters.selectedItens.length === 0
    },
    selectedScheduleHasItens () {
      return this.$store.getters.selectedScheduleHasItens
    },
    hasCategorySelectedAndSelectedItens () {
      return this.$store.getters.hasCategorySelectedAndSelectedItens
    },
    alteredScheduleSaving () {
      return this.$store.getters.alteredScheduleSaving
    }
  }
}
</script>
<style>
.loading-modal-scheule{
  position: absolute;
  right: 0;
  left: 0;
  bottom:0;
  margin: 0;
}
.item-box{
  border: 1px solid #bdbdbd;
  border-radius: 15px;
  float: left;
}
.item-imagem{
  width: 60px;
  float: left;
}
.item-detalhes{
  float: left;
  width: calc(100% - 60px);
  width: -moz-calc(100% - 60px);
}
.item-imagem img{
  height: 50px;
  width: 50px;
  border-radius: 100%;
  margin-right: 10px;
}
.item-detalhes .item-titulo{
  font-size: 20px;
  margin-bottom: 0px;
}

.item-preco, .item-rodape, .item-cabecalho{
  float: left;
  width: 100%;
}
/* ajustes */
p{
color: #838789
}
.search-text{
  color:#b1b1b1;
  font-size: 18px;
}
.search-text span{
  color: #e24054;
  font-weight: bold;
}
.no-details .input-group__details{
  display: none!important
}
.no-details .input-group{
  padding: 3px;
  padding-left: 10px;
  border: 1px solid #b1b1b1;
  border-radius: 4px;
}
.top-2{
  top: -2px;
  position: relative;
}
</style>



// WEBPACK FOOTER //
// index.vue?26056f70